import type { ReplyOwnership } from './tickets';

export interface SendOutboundParams {
  branchId: string;
  phone: string;
  mode: 'text' | 'template';
  text?: string;
  templateName?: string;
  /** The approved language picked with the name (a name can exist in several). */
  templateLanguage?: string;
  /** N body-variable values. Replaces the deprecated companyName alias. */
  params?: string[];
  /** @deprecated Use params instead. Kept for backward compatibility. */
  companyName?: string;
  /** Stable for the logical submit; the backend reserves it before Graph. */
  clientMessageId: string;
}

export interface SendOutboundError {
  status: number;
  error: string;
  /** Present on 'assigned_to_other': the display name of the owning agent. */
  agentName?: string;
}

export async function sendOutboundMessage(
  params: SendOutboundParams,
): Promise<{ ticketId: string; ownership?: ReplyOwnership }> {
  const res = await fetch('/api/messages/send', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
    credentials: 'include',
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string; agentName?: string };
    throw {
      status: res.status,
      error: body.error ?? 'unknown',
      ...(body.agentName ? { agentName: body.agentName } : {}),
    } satisfies SendOutboundError;
  }
  return res.json() as Promise<{ ticketId: string; ownership?: ReplyOwnership }>;
}
